import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { InfoCobrancaChamado } from '../../interfaces/info-cobranca-chamado';

@Component({
  selector: 'app-info-cobranca-chamado',
  templateUrl: './info-cobranca-chamado.component.html',
  styleUrls: ['./info-cobranca-chamado.component.scss']
})
export class InfoCobrancaChamadoComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public infoCobranca: InfoCobrancaChamado,
    private dialogRef: MatDialogRef<InfoCobrancaChamadoComponent>
  ) { }

  isNumber(val: number | string) {
    return typeof val === 'number';
  }

  confirmar() {
    this.dialogRef.close(true);
  }
}
